<script>
export default {
  data () {
    return {
    }
  },
  computed: {
    channel () {
      return this.$store.getters.channel
    }
  },
  methods: {
    getChannel (id) {
      this.$store.dispatch('getChannel', id)
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.getChannel(to.params.id)
    })
  },
  mounted () {
  },
  route: {
  }
}
</script>



// WEBPACK FOOTER //
// Channel.vue?85654aa8